import axios from './axiosInstances/axiosInstance';
import AppPermissionName from 'src/types/AppPermissionName';
import PrivilegesPermissionName from 'src/types/PrivilegesPermissionName';

export type AppParam = {
  name: AppPermissionName;
  value: boolean;
};
export type Privileges = {
  privilegeId: string;
  privilegeName: PrivilegesPermissionName;
};

export type UserDetailsResponse = {
  userId: string;
  userName: string;
  appParam: AppParam[];
  timeZone: string;
  timeZoneName: string;
  dateFormat: string;
  baseURL: string;
  accountId: number;
  orgId: number;
  orgName: string;
  environment: string;
  crm_name: string;
  pendoUserId: string;
  changePasswordFlag: any;
  hasAppAdminPriv: boolean;
  skinName: string;
  emailId: string;
  otherPrivileges: Privileges[];
  enableAggregateUsage: boolean;
  expireWarningMessage: string;
};

const API_URL = '/qs/account/user/getdetails';

export const getUserDetails = (token: string): Promise<UserDetailsResponse> => {
  /**
   * Just uncomment this if you're tired from expired token and ready to work with the stale one :)
   * since most APIs work with stale tokens just fine ...
   */
  // return import('src/__mocks__/userDetails.json').then(m => m.default as UserDetailsResponse);

  return axios.get(API_URL, {
    params: {
      token: token,
    },
  });
};